import { createAction, props } from '@ngrx/store';
import { ResponsePassiveDocumentCreation } from '../../shared/interfaces';
import { PassiveDocumentCreationTypes } from '../../shared/enums';

export const getPassiveDocumentCreation = createAction(
    PassiveDocumentCreationTypes.PASSIVE_DOCUMENT_CREATION,
    props<{ request }>()
);

export const getPassiveDocumentCreationSucess = createAction(
    PassiveDocumentCreationTypes.PASSIVE_DOCUMENT_CREATION_SUCCESS,
    props<{ response: ResponsePassiveDocumentCreation }>()
);

export const getPassiveDocumentCreationError = createAction(
    PassiveDocumentCreationTypes.PASSIVE_DOCUMENT_CREATION_ERROR,
    props<{ payload: any }>()
);

export const cleanState = createAction(
    PassiveDocumentCreationTypes.CLEAN_STATE
);

